interface Props {
  className?: string;
}

export default function PowerIcon({className}: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 13 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.5 8C6 8 6 8 6 8V0.000229284C6 0.000229284 6.22 0 6.5 0L7 0.000229284V8C7 8 7 8 6.5 8Z"
        fill="currentColor"
      />
      <path
        d="M6.5 14.0005C2.92 14.0005 0 11.1805 0 7.72053C0 5.31053 1.46 3.08053 3.72 2.04053L4.13 2.95053C2.22 3.82053 0.99 5.69053 0.99 7.72053C0.99 10.6305 3.46 13.0005 6.49 13.0005C9.52 13.0005 11.99 10.6305 11.99 7.72053C11.99 5.70053 10.76 3.82053 8.85 2.95053L9.26 2.04053C11.52 3.07053 12.98 5.30053 12.98 7.72053C12.98 11.1805 10.06 14.0005 6.48 14.0005H6.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
